import {AddressModel} from './address.model';

export class AccountModel {
  id: string;
  address: AddressModel;
  billingAccountNumber: string;
  foundationAccountNumber: string;
  businessName?: any;
  market?: any;
  subMarket?: any;
}
